import { CheckCircle2, X } from "lucide-react";
import { toast } from "sonner";

interface CartToastProps {
  toastId: string | number;
  productName: string;
}

const CartToastInner = ({ toastId, productName }: CartToastProps) => {
  const handleCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    toast.dismiss(toastId);
    // Use history API directly to avoid requiring Router context inside sonner portal
    window.history.pushState({}, "", "/checkout");
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <div
      role="status"
      className="pointer-events-auto flex w-[360px] max-w-[90vw] items-start gap-3 rounded-xl border border-border bg-background p-4 shadow-[0_10px_40px_rgba(0,0,0,0.15)]"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary">
        <CheckCircle2 className="h-5 w-5 text-primary-foreground" strokeWidth={2.5} />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-base font-bold text-foreground leading-tight">
          Товар добавлен в корзину
        </p>
        <p className="mt-0.5 text-[13px] text-muted-foreground truncate">
          {productName}
        </p>
        <a
          href="/checkout"
          onClick={handleCheckout}
          className="mt-3 inline-flex h-9 items-center justify-center rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Оформить заказ
        </a>
      </div>

      <button
        type="button"
        aria-label="Закрыть"
        onClick={() => toast.dismiss(toastId)}
        className="shrink-0 rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export const showCartToast = (productName: string) => {
  try {
    toast.custom((id) => <CartToastInner toastId={id} productName={productName || "Товар"} />, {
      duration: 4000,
    });
  } catch (err) {
    console.error("showCartToast failed:", err);
    // Fallback to a plain toast that cannot crash
    try {
      toast.success(`Добавлено: ${productName || "товар"}`);
    } catch {
      // ignore
    }
  }

  // Haptic feedback on mobile — guarded
  try {
    if (typeof navigator !== "undefined" && typeof (navigator as Navigator).vibrate === "function") {
      (navigator as Navigator).vibrate(50);
    }
  } catch {
    // ignore
  }
};
